import { AssetListPayload } from "../pages/content/Content";
import baseURL from "./axiosInstance";

export const fetchCategoriesDropDown = async () => {
  try {
    const response = await baseURL.get(`/Content/Categories/list`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchMediaTypesDropDown = async () => {
  try {
    const response = await baseURL.get(`/Content/MediaTypes/list`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchStatusesDropDown = async () => {
  try {
    const response = await baseURL.get(`/Home/list/status`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchOrientationDropDown = async () => {
  try {
    const response = await baseURL.get(`/Home/list/orientation`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getFile = async (filepath: string) => {
  try {
    const response = await baseURL.get(`/Content/GetFile`, {
      params: { filepath }, // Attach filepath as query parameter
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching file:", error);
    throw error;
  }
};

export const fetchStatusList = async () => {
  try {
    const response = await baseURL.get("/Home/list/status");
    return response.data;
  } catch (error) {
    console.error("Error fetching status list:", error);
    return [];
  }
};


export const submitContent = async (formData: FormData) => {
  try {
    var response = baseURL.post(`/Content/Upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const UpdateContent = async (formData: FormData) => {
  try {
    var response = baseURL.put(`/Content/Update`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getContent = async (id: string|number) => {
  try {
    var response = baseURL.get(`/Content/view/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchContent = async (data:AssetListPayload) => {
  try {
    let params : AssetListPayload = {
      PageNo:data.PageNo, // Pass page number
      PageSize:data.PageSize,
    };
    if( data?.Status) params.Status = data?.Status;
    if( data?.FileSize) params.FileSize = data?.FileSize;
    if( data?.CategoryIds?.length) params.CategoryIds = data?.CategoryIds;
    if( data?.MediaTypesIds?.length) params.MediaTypesIds = data?.MediaTypesIds;
    if( data?.PublishStartDate) params.PublishStartDate = data?.PublishStartDate;
    if( data?.PublishEndDate) params.PublishEndDate = data?.PublishEndDate;
    if( data?.ModifiedStartDate) params.ModifiedStartDate = data?.ModifiedStartDate;
    if( data?.ModifiedEndDate) params.ModifiedEndDate = data?.ModifiedEndDate;
    if( data?.SearchText) params.SearchText = data?.SearchText;

    
    const response = await baseURL.post(`/Content/list`, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteContent = async (id: string, deleteFlag: boolean) => {
  try {
    const response = await baseURL.delete(`Content/delete`, { 
      data: {
        id, 
        delete: deleteFlag, 
      },
     });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const publishContent = async (id: string, status: number) => {
  try {
    const response = await baseURL.post(`Content/publish`, { id, status });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchImageGeneratedDataFromChatgpt = async (formData:FormData) => {
  try {
    const response = await baseURL.post(`/Content/generateTagsAndColors`, formData,{
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchFileSizes = async () => {
  try {
    var response = baseURL.get(`/Home/list/fileSizes`);
    return response;
  } catch (error) {
    throw error;
  }
};